<template>
  <div>
    <b-card>
      <b-table
        responsive="sm"
        :items="items"
        :fields="fields"
      >
        <template #cell(action)="data">
          <b-row>
            <b-col md="auto">
              <b-button
                variant="success"
                @click="openUpdateModal(data.item)"
              >
                <feather-icon
                  icon="EditIcon"
                  class="mr-25"
                /></b-button>
            </b-col>
            <b-col md="auto">
              <b-button
                variant="danger"
                @click="deleteSubCategory(data.item.id)"
              >
                <feather-icon
                  icon="DeleteIcon"
                  class="mr-25"
                /></b-button>
            </b-col>
          </b-row>
        </template>
        <template #cell(link_status)="data">
          <b-badge
            :variant="data.item.link_status == 1 ? 'success' : 'danger'"
          >
            {{ data.item.link_status == 1 ? "Active" : "Expired" }}
          </b-badge>
        </template>
      </b-table>
    </b-card>
    <b-modal
      ref="updatemodal"
      v-model="show"
      hide-footer
      title="Update Sub Category"
    >
      <UpdateMeeting :meetingdata="selectedItem" />
    </b-modal>
  </div>
</template>

<script>
import UpdateMeeting from '@/views/MeetingManagement/Components/UpdateMeeting.vue'
import {
  BModal,
  BCard,
  BTable,
  BBadge,
  BButton,
  BCol,
  BRow,
  BCardText,
  BAvatar,
  BLink,
  BContainer,
} from 'bootstrap-vue'
import meetingApi from '@/Api/Modules/meetings'

export default {
  name: 'MeetingTable',
  components: {
    BCard,
    UpdateMeeting,
    BModal,
    BButton,
    BCol,
    BBadge,
    BAvatar,
    BTable,
    BRow,
    BContainer,
    BCardText,
    BLink,
  },

  data() {
    return {
      show: false,
      selectedItem: {},
      data: {},
      fields: [
        {
          key: 'batch',
          label: 'Batch',
          sortable: true,
        },
        {
          key: 'intake',
          label: 'Intake',
          sortable: true,
        },
        {
          key: 'meeting_id',
          label: 'Meeting Link',
          sortable: true,
        },
        {
          key: 'current_month',
          label: 'Month Number',
          sortable: true,
        },
        {
          key: 'link_status',
          label: 'Link Status',
          sortable: true,
        },

        {
          key: 'action',
          label: 'Action',
          sortable: true,
        },
      ],
      items: [],
    }
  },
  async created() {
    await this.AllMeetings()
  },

  methods: {
    setCellPadding(value, key, item) {
      // Add a custom class to table cells based on your requirements
      return 'custom-cell-padding'
    },
    async AllMeetings() {
      await this.$vs.loading({
        scale: 0.8,
      })
      const res = await meetingApi.allMeetings()
      this.items = res.data.data
      this.$vs.loading.close()
    },

    async deleteSubCategory(id) {
      await this.$vs.loading({
        scale: 0.8,
      })
      await meetingApi
        .deleteMeeting(id)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    openUpdateModal(item) {
      this.selectedItem = item
      this.show = true
    },
  },
}
</script>

<style>
.custom-cell-padding {
  height: 70px; /* Set your desired padding value */
}
</style>
